import { IBiReportsVideoUrl } from '../../types/redux';

const initialState: IBiReportsVideoUrl = {
  url: '', //Ссылка на видео будет получена из runtime setting
};

export const biReportsVideoUrlReducer = (state: IBiReportsVideoUrl = initialState) => {
  return state;
};
